import {
  queryForProductRecommendationsAndBigCommerceCategories,
  mapRecommendationsToCategorySlug,
  mapBCCategorySlugsToRecommendedProductType,
  removeDuplicates,
  filterOutCategoriesWithoutAvailableProductVariants,
} from './getRecommendationsForCrossSell.utils'
import { IProductCategory } from 'types/contentful/productCategory'
import { Entry } from 'contentful'
import { loadAllProductSlugsFromContentful } from '@utils/contentful/load-all-product-slugs'
import { getProductTileData } from '@components/category/ProductSlider/ProductSlider.utils'
import { ProductVariant } from '@commerce/types'
import { TProductTileData } from 'app/(main)/(catalog)/category/[slug]/_components/ProductTile/ProductTile.types'

export async function getRecommendationsForCategory({
  category,
  cartItems = [],
  overrideProducts = [],
  preview = false,
}: {
  category: string
  cartItems?: string[]
  overrideProducts?: Entry<IProductCategory>[]
  preview: boolean
}) {
  if (!category) {
    return []
  }
  const { recommendations, bigCommerceCategories } =
    await queryForProductRecommendationsAndBigCommerceCategories(category)

  const recommendationsAsSlugs =
    mapRecommendationsToCategorySlug(recommendations, bigCommerceCategories) ||
    []

  const recommendedProducts = await mapBCCategorySlugsToRecommendedProductType(
    recommendationsAsSlugs,
    preview
  )

  const recommendedProductsWithOverrides = [
    ...overrideProducts,
    ...recommendedProducts,
  ].filter((x) => x)

  const uniqueRecommendedProducts = removeDuplicates(
    recommendedProductsWithOverrides
  )

  const availableRecs = uniqueRecommendedProducts
    .filter((r) => !cartItems.includes(r?.fields?.productSlug))
    .filter(
      (product) => product?.fields?.productSlug && product?.fields?.productName
    )

  const filteredRecs: (Entry<IProductCategory> & {
    productVariants?: ProductVariant[]
  })[] = await filterOutCategoriesWithoutAvailableProductVariants(
    availableRecs,
    8
  )

  const allProductSlugs = await loadAllProductSlugsFromContentful()

  const parsedRecommendedProducts: TProductTileData[] = filteredRecs.map(
    (rec) =>
      getProductTileData({
        productCategoryWithVariants: rec,
        allProductSlugs,
      })
  )

  return parsedRecommendedProducts
}
